import { Suspense } from 'react';

import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

import { ChartsThemeProvider } from '@/context/chartsThemeContext';
import { ConfigProvider } from '@/context/configContext';
import { showDevTools } from '@/utils/showDevTools';

const Main = () => {
    return (
        <>
            <div className="h-full font-sans dark:text-white">
                <ConfigProvider>
                    <ChartsThemeProvider>
                        <Suspense
                            fallback={
                                <div className="self-center">Loading...</div>
                            }
                        >
                            <Outlet />
                        </Suspense>
                    </ChartsThemeProvider>
                </ConfigProvider>
            </div>
            {showDevTools() && <TanStackRouterDevtools />}
        </>
    );
};

export const Route = createRootRouteWithContext<{
    auth: {
        isAuthenticated: boolean;
    };
    queryClient: QueryClient;
}>()({
    component: Main,
});
